/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeXDSMWeihnachtenDto
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type xDSMGetWeihnachtenResponse200 = {
  data: ApiEnvelopeXDSMWeihnachtenDto
  status: 200
}

export type xDSMGetWeihnachtenResponseSuccess = (xDSMGetWeihnachtenResponse200) & {
  headers: Headers;
};
;

export type xDSMGetWeihnachtenResponse = (xDSMGetWeihnachtenResponseSuccess)

export const getXDSMGetWeihnachtenUrl = () => {




  return `/api/XDSM/weihnachten`
}

export const useXDSMGetWeihnachtenHook = (): ( options?: RequestInit) => Promise<xDSMGetWeihnachtenResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getXDSMGetWeihnachtenUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


